import { Pipe, PipeTransform } from '@angular/core';
import { statusEnum } from '../../enums/status';
import { RequestScheduleType } from 'all-libraries/ibusiness-core/src/core';
import { injectFloatingLayout } from '../../../core/common/helpers/system-tabs-layout/system-tabs-layout';

import { STATUS_BADGE_CLASS } from '../../lib/badge/badge.constants';

export { STATUS_BADGE_CLASS };

const soft = (bg: string, text: string) =>
  // Important (`!`) so the soft colours win over the `text-white` callers add to badgeClass.
  `${bg}! ${text}! font-semibold! ${STATUS_BADGE_CLASS}`;

const SUCCESS = soft('bg-success-50', 'text-success-700');
const WARNING = soft('bg-warning-50', 'text-warning-700');
const DANGER = soft('bg-destructive-50', 'text-destructive-700');
// New and Draft keep their solid primary pill, only gaining the dot.
const PRIMARY = `bg-primary-500 text-white ${STATUS_BADGE_CLASS}`;
const NEUTRAL = soft('bg-neutral-100', 'text-neutral-700');

/**
 * UI_Version_2 (System_Default_Color): soft pills with a dot. Statuses not listed keep their legacy
 * classes. New and Draft stay the solid primary pill, with the dot.
 */
export const SOFT_STATUS_CLASSES: Record<string, string> = {
  [statusEnum.QUALIFIED]: SUCCESS,
  [statusEnum.ACTIVE]: SUCCESS,
  [statusEnum.COMPLETED]: SUCCESS,
  [statusEnum.APPROVED]: SUCCESS,
  [statusEnum.PUBLISHED]: SUCCESS,
  [statusEnum.PAYMENT]: SUCCESS,
  [statusEnum.PENDING]: WARNING,
  [statusEnum.INPROGRESS]: WARNING,
  [statusEnum.UNDER_MODIFICATION]: WARNING,
  [statusEnum.PENDING_QUALIFICATION]: WARNING,
  [statusEnum.REJECTED]: DANGER,
  [statusEnum.INACTIVE]: DANGER,
  [statusEnum.CANCELLED]: DANGER,
  [statusEnum.REFUND]: DANGER,
  [statusEnum.NEW]: PRIMARY,
  [statusEnum.DRAFT]: PRIMARY,
  [statusEnum.REVIEW]: NEUTRAL,
  [statusEnum.NOT_STARTED]: NEUTRAL,
  [statusEnum.EXPIRED]: soft('bg-neutral-200', 'text-neutral-800'),
};

@Pipe({
  name: 'status',
  standalone: true,
})
export class StatusPipe implements PipeTransform {
  private readonly uiVersion2 = injectFloatingLayout();

  transform(value: string): string {
    if (this.uiVersion2() && SOFT_STATUS_CLASSES[value]) {
      return SOFT_STATUS_CLASSES[value];
    }

    switch (value) {
      case statusEnum.QUALIFIED:
      case statusEnum.ACTIVE:
      case statusEnum.COMPLETED:
      case statusEnum.APPROVED:
      case statusEnum.PUBLISHED:
        return 'bg-success-500 text-white';

      case statusEnum.PENDING:
      case statusEnum.INPROGRESS:
      case statusEnum.UNDER_MODIFICATION:
        return 'bg-warning-500 text-white';

      case statusEnum.PENDING_QUALIFICATION:
        return 'bg-warning-700 text-white';

      case statusEnum.REJECTED:
      case statusEnum.INACTIVE:
      case statusEnum.CANCELLED:
        return 'bg-destructive-500 text-white';

      case statusEnum.NEW:
      case statusEnum.DRAFT:
        return 'bg-primary-500 text-white';

      case statusEnum.EXPIRED:
        return 'bg-neutral-900 text-white';

      case statusEnum.NOT_STARTED:
        return 'bg-neutral-50 text-neutral-700';

      case statusEnum.REVIEW:
        return 'bg-neutral-500 text-white';

      case statusEnum.SKIPPED:
      case statusEnum.NO_ACTION:
        return '';

      case statusEnum.PAYMENT:
        return 'bg-success-500 text-white';

      case statusEnum.REFUND:
        return 'bg-destructive-500 text-white';

      case RequestScheduleType.ONE_TIME:
        return 'bg-neutral-50 text-neutral-500';

      case RequestScheduleType.DAILY:
        return 'bg-primary-50 text-primary-500';

      case RequestScheduleType.WEEKLY:
        return 'bg-warning-50 text-warning-500';

      case RequestScheduleType.MONTHLY:
        return 'bg-destructive-50 text-destructive-500';

      case RequestScheduleType.YEARLY:
        return 'bg-success-50 text-success-500';

      case RequestScheduleType.RECURRING:
        return 'bg-primary-50 text-primary-500';
    }
    return '';
  }
}
